import React from 'react'
import './Ourteam.css'

function Ourteam() {
    return (
        <div className="main-ourteam-container">
            {/* Hero section with image and overlay text */}
            <div className="ourteam-hero">
                <div className="ourteam-overlay">
                    <h1>Our Team</h1>
                </div>
            </div>

            {/* White gap */}
            <div className="white-gap"></div>
            
            {/* Team Members Table */}
            <div className="team-table-container">
                <table className="team-table">
                    <thead>
                        <tr>
                            <th className='text-center'>Name</th>
                            <th className='text-center'>Designation</th>
                            <th className='text-center'>Contact Detail</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td> Syed Sajid Ali </td>
                            <td>Director</td>
                            <td><a href="mailto:sajid@centrexmarineservices.com" className="email-link">sajid@centrexmarineservices.com</a></td>
                        </tr>
                        <tr>
                            <td>Syed Hussnain Raza</td>
                            <td>Director</td>
                            <td><a href="mailto:shr@centrexmarineservices.com" className="email-link">shr@centrexmarineservices.com</a></td>
                        </tr>
                        <tr>
                            <td> Syed Nawazish Ali</td>
                            <td>Business Development</td>
                            <td><a href="mailto:nawazish@centrexmarineservices.com" className="email-link">nawazish@centrexmarineservices.com</a></td>
                        </tr>
                        <tr>
                            <td>Syed Shahzaib Haider</td>
                            <td>Business Development</td>
                            <td><a href="mailto:shahzaib@centrexmarineservices.com" className="email-link">shahzaib@centrexmarineservices.com</a></td>
                        </tr>
                        <tr>
                            <td>Asif Ali Nadeem</td>
                            <td>Business Development Operations</td>
                            <td><a href="mailto:asif@centrexmarineservices.com" className="email-link">asif@centrexmarineservices.com</a></td>
                        </tr>
                    
                    </tbody>
                </table>
            </div>

             <div className="team-table-container">
                <h2 className='text-center mb-3'>Staff Contact
                </h2>
                <table className="team-table">
                    <thead>
                        <tr>
                            <th className='text-center'>Designation</th>
                            <th className='text-center'>Contact Detail</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Sales Department</td>
                            <td><a href="mailto:sales.skt@centrexmarineservices.com" className="email-link">sales.skt@centrexmarineservices.com</a></td>
                        </tr>
                        <tr>
                            <td> Import department</td>
                            <td><a href="mailto:import@centrexmarineservices.com" className="email-link">import@centrexmarineservices.com</a></td>
                        </tr>
                        <tr>
                            <td>Documentation department</td>
                            <td><a href="mailto:docs.skt@centrexmarineservices.com" className="email-link">docs.skt@centrexmarineservices.com</a></td>
                        </tr>
                        <tr>
                            <td>Accounts Department </td>
                            <td><a href="mailto:accounts@centrexmarineservices.com" className="email-link">accounts@centrexmarineservices.com</a></td>
                        </tr>
                        <tr>
                            <td>Customer Services</td>
                            <td><a href="mailto:csv.lhr@centrexmarineservices.com" className="email-link">csv.lhr@centrexmarineservices.com</a></td>
                        </tr>
                    
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Ourteam
